import { forwardRef, Type } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';

export function ngValidatorAccessor(type: Type<any>) {
  return {
    provide: NG_VALIDATORS,
    useExisting: forwardRef(() => type),
    multi: true,
  };
}
